module.exports = __webpack_public_path__ + "img/orange.bdf2c019.jpg";